export const FEEDBACK_CATEGORIES = [
  { value: 'bug_report', label: 'Bug Report' },
  { value: 'feature_request', label: 'Feature Request' },
  { value: 'ui_ux', label: 'UI/UX Improvement' },
  { value: 'performance', label: 'Performance Issue' },
  { value: 'payment', label: 'Payment Issue' },
  { value: 'attendance', label: 'Attendance' },
  { value: 'fees', label: 'Fees' },
  { value: 'payroll', label: 'Payroll' },
  { value: 'reports', label: 'Reports' },
  { value: 'mobile_app', label: 'Mobile App' },
  { value: 'other', label: 'Other' },
];

export const FEEDBACK_PRIORITIES = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'critical', label: 'Critical' },
];

export const FEEDBACK_SUBMIT_TO = [
  { value: 'school', label: 'School' },
  { value: 'software', label: 'Software' },
];

export const FEEDBACK_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'under_review', label: 'Under Review' },
  { value: 'planned', label: 'Planned' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'testing', label: 'Testing' },
  { value: 'completed', label: 'Completed' },
  { value: 'rejected', label: 'Rejected' },
];

export const FEEDBACK_STATUS_TRANSITIONS = {
  new: ['under_review', 'rejected'],
  under_review: ['planned', 'rejected'],
  planned: ['in_progress', 'rejected'],
  in_progress: ['testing', 'rejected'],
  testing: ['completed', 'rejected'],
  completed: [],
  rejected: [],
};

export const FEEDBACK_ALLOWED_FILE_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
export const FEEDBACK_ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'pdf'];
export const FEEDBACK_MAX_FILE_SIZE = 5 * 1024 * 1024;

export function feedbackCategoryLabel(value) {
  return FEEDBACK_CATEGORIES.find((c) => c.value === value)?.label || value || '—';
}

export function feedbackPriorityLabel(value) {
  return FEEDBACK_PRIORITIES.find((p) => p.value === value)?.label || value || '—';
}

export function feedbackSubmitToLabel(value) {
  return FEEDBACK_SUBMIT_TO.find((s) => s.value === value)?.label || value || '—';
}

export function feedbackStatusLabel(value) {
  return FEEDBACK_STATUSES.find((s) => s.value === value)?.label || value || '—';
}

export function feedbackStatusBadgeClass(status) {
  switch (status) {
    case 'new':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';
    case 'under_review':
      return 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300';
    case 'planned':
      return 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300';
    case 'in_progress':
      return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300';
    case 'testing':
      return 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-300';
    case 'completed':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300';
    case 'rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300';
    default:
      return 'bg-muted text-muted-foreground';
  }
}

export function validateFeedbackFile(file) {
  if (!file) return null;
  const ext = file.name.split('.').pop()?.toLowerCase();
  if (!ext || !FEEDBACK_ALLOWED_EXTENSIONS.includes(ext)) {
    return 'Allowed file types: PNG, JPG, JPEG, PDF';
  }
  // Images are auto-compressed to ≤100KB; PDFs keep 5MB limit.
  const isImage = ['png', 'jpg', 'jpeg'].includes(ext) || String(file.type || '').startsWith('image/');
  if (!isImage && file.size > FEEDBACK_MAX_FILE_SIZE) {
    return 'File must be under 5MB';
  }
  return null;
}
